import { render, staticRenderFns } from "./userSeniorPhone.vue?vue&type=template&id=676e246a&scoped=true&"
import script from "./userSeniorPhone.vue?vue&type=script&lang=js&"
export * from "./userSeniorPhone.vue?vue&type=script&lang=js&"
import style0 from "./userSeniorPhone.vue?vue&type=style&index=0&id=676e246a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676e246a",
  null
  
)

export default component.exports